import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';

import { INavItem } from '../../common/utils';

const getNavList = (): INavItem[] => {
  const extraNavList = app.forum.attribute('extraNavNavList');

  try {
    return JSON.parse(extraNavList as any);
  } catch (e) {
    console.error(e);
  }

  return [];
};

export default class NavList extends Component {
  view() {
    const navList = getNavList();

    return (
      <div className="ExtraNav-list-container">
        {navList.map((item, index) => (
          <Link
            key={index}
            className="ExtraNav-list-item"
            href={item.link}
            onclick={(e: Event) => {
              if (!item.link.startsWith(location.origin)) {
                window.open(item.link);
              }
            }}
          >
            <img className="ExtraNav-list-item-image" src={item.image} />
            <div className="ExtraNav-list-item-title">{item.title}</div>
          </Link>
        ))}
      </div>
    );
  }
}
